import { MiddlewareAPI, Dispatch, AnyAction, Middleware } from 'redux';
import RootState from 'constants/RootState';
import { remotingConstants } from '@lifesize/clients.remoting';
import AppActionTypes from 'constants/ActionTypes';
import ActionTypes from 'constants/ActionTypes';
import homeSelector from 'selectors/home';

const secondsTillIdle = 300;

let idleTimerId = 0;

function clearAndResetTimer(store: any) {
  clearTimeout(idleTimerId);
  idleTimerId = window.setTimeout(() => {
    // One last hard check: we never, ever want to reload near a presentation
    const isPresenting = homeSelector(store.getState()).isPresenting;
    if (isPresenting) {
      return clearAndResetTimer(store);
    }
    location.reload();
  }, secondsTillIdle * 1000);
}

// This middleware is responsible for deciding when to trigger a page refresh
const updateMiddleware = (store: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {

  const isUpdateReadyAction: boolean = action.type === ActionTypes.UpdateReady;

  // If the timer isn't running yet, we should only start it if the update is ready
  if (!idleTimerId) {
    if (isUpdateReadyAction) {
      clearAndResetTimer(store); // Start the timer
    } else {
      return next(action);
    }
  }

  const state: RootState = store.getState();

  // If it's a user interaction, reset the idle timer
  const isRemotingAppAction: boolean = Object.keys(remotingConstants.app.actions).some(
    (k) => remotingConstants.app.actions[k] === action.type);
  const isAppAction: boolean = Object.keys(AppActionTypes).some(
    (k) => AppActionTypes[k] === action.type);
  const isPresenting = homeSelector(state).isPresenting;
  // The update is ready, but these actions push back the idle timer
  if (
    isRemotingAppAction ||
    isAppAction ||
    isPresenting
  ) {
    // Reset the idle timer
    clearAndResetTimer(store);
  }
  return next(action);
};

export default updateMiddleware as Middleware;



// WEBPACK FOOTER //
// ./src/middleware/update.ts